export default __webpack_public_path__ + "static/media/kh.2d49a6a0.svg";